<template>
  <model-form
    ref="modelForm"
    :model="item"
  >
    <div class="column q-gutter-md">
      <item-detail
        :item="item"
      />
      <item-variation-table
        class="q-mb-md"
        :item="item"
      />
      <item-modifier-set-table
        :item="item"
      />
    </div>
  </model-form>
</template>

<script>
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import ItemDetail from 'src/modules/admin/item/components/ItemDetail'
import ItemModifierSetTable from 'src/modules/admin/item/components/ItemModifierSetTable'
import ItemVariationTable from 'src/modules/admin/item/components/ItemVariationTable'

export default {
  name: 'ItemForm',
  components: {
    ModelForm,
    ItemDetail,
    ItemVariationTable,
    ItemModifierSetTable
  },
  models: {
    item: {
      taxes: 'default',
      modelAudits: true,
      itemVariations: {
        inventoryAvailabilitiesAndConstraintsByLocationAndRegisterStation: true,
        inventoryRecipes: true,
        disableEditCostCents: true,
        libraryParentId: true,
        receiveLibraryUpdates: true,
        priceTierPrices: true
      },
      location: true,
      locations: true,
      itemModifierSets: {
        defaultModifiers: true,
        modifierSet: true
      },
      editing: true,
      libraryChildSiteIds: true
    }
  },
  methods: {
    show (model, _initialData) {
      this.$refs.modelForm.show(model, {
        itemVariations: [{
          name: 'Regular',
          price: 0
        }]
      })
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
